import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

export const DragAndDropContext = DragDropContext;
export const DroppableContext = Droppable;
export const DraggableContext = Draggable;

export const handleDragEnd = (result, items, setItems) => {
    if (!result.destination) return;

    const reorderedItems = Array.from(items);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    const updatedItems = reorderedItems.map((item, index) => ({
        ...item,
        order: index + 1,
    }));

    setItems(updatedItems);
};